//
// ResponsiveLayoutOverflowType.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var ResponsiveLayoutOverflowType = {
    SCROLL:0,
    FIT:1,
    GROW:2,
    STACK:3
};
export default ResponsiveLayoutOverflowType;
